import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import supabase from '../../../../supabaseClient';

const AssignmentDetail = () => {
  const { assignmentId } = useParams();
  const [assignment, setAssignment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAssignment = async () => {
      setLoading(true);
      const { data, error } = await supabase
        .from('academy_assignments')
        .select('*')
        .eq('id', assignmentId)
        .single();
      if (error) setError(error.message);
      else setAssignment(data);
      setLoading(false);
    };
    fetchAssignment();
  }, [assignmentId]);

  if (loading) return <div>Loading assignment...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!assignment) return <div>Assignment not found.</div>;

  return (
    <div className="academy-page-shell assignment-detail-page">
      <div className="assignment-detail">
        <h2>{assignment.title}</h2>
      <p>{assignment.description}</p>
      <button onClick={() => navigator.clipboard.writeText(window.location.href)}>
        Copy Link
      </button>
    </div>
  </div>
);
};

export default AssignmentDetail;
